export const isProduction = import.meta.env.VITE_ENV === "production";
